import { http } from '@api/client';
import { paramterize, pickResponse, pickResult } from '@api/utils';

export interface PersonContentRelation {
  person_name: string;
  person_vtr_id: string;
  content_name: string;
  content_vtr_id: string;
  content_type: string;
  content_language: string;
  content_genre: string;
  content_status: string;
  release_year: string;
  role: string;
  sub_role: string;
  source: string;
  ingestion_method: string;
  modified_at: string | null;
  modified_by: string;
  person_content_relation_id: string;
}

export function get(vtr_relation_id: string) {
  return http
    .get(`/person-content-relation/${vtr_relation_id}`)
    .pipe(pickResult());
}

type EditP2CPayload = {
  person_vtr_id: string;
  content_vtr_id: string;
  role: string;
  sub_role: string;
}

export function post(payload) {
  const associated_content = payload?.associated_content?.map((content) => {
    return {
      "content_vtr_id": content?.vtr_id,
      "role": content?.role ?? "",
      "sub_role": content?.sub_role ?? ""
    }
  })

  const p2cPayload = {
    "person_vtr_id": payload?.persons[0]?.vtr_id ?? "",
    associated_content,
    "source_links": payload?.sources
  }
  return http.post(`/person-content-relation`, p2cPayload)
    .pipe(pickResult());
}

export function put(person_content_rel_id = "", payload) {
  return http
    .put(`/person-content-relation/${person_content_rel_id}`, payload)
    .pipe(pickResult());
}

export function deleteP2C({ person_content_rel_id = "" }: { person_content_rel_id: string }) {
  return http
    .delete(`/person-content-relation/${person_content_rel_id}`)
    .pipe(pickResult());
} 